'use client'

import { Flex } from '@chakra-ui/react'
import React from 'react'

const ImageViewer = ({
  fileUrl,
  fileName,
}: {
  fileUrl: string
  fileName: string
}) => {
  return (
    <Flex justify="center" align="center" height="100%" p={4}>
      <img
        src={fileUrl}
        alt={fileName}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
        }}
      />
    </Flex>
  )
}

export default ImageViewer
